import React from "react";
import { Box } from "@mui/material";
import Text from "../../components/Text";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Content } from "../../components/Grid";

const AllDApps = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Text
        fontSize={30}
        fontWeight={700}
        color={theme.palette.primary.main}
        className="sticky top-14 z-40"
        style={{
          fontFamily: "Righteous",
          padding: isMobile ? "10px 30px" : "10px 50px",
          background: "#EAF7E6",
        }}
      >
        Registered Dapps
      </Text>
      <Box
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "flex-start",
          padding: isMobile ? "10px 0px 50px 50px" : "30px 50px 50px 50px",
        }}
      >
        {/* <Card
          title="KOLnet"
          description="KOLnet is a disruptive project to the Defi ecosystem. The perfect mix of Defi and Marketing tech to bring about the world’s first Marketing Pools. KOLnet monetises key opinion leaders, decentralises crowd influence by utilizing token swaps through multi-chain token pools."
          id="1"
        />
        <Card
          title="PhoenixDAO"
          description="A digital identity-based suite of protocols and products designed to power the new digital economy covering DeFi, NFT to decentralized governance through authentication, payments, and linked identity."
          id="2"
        />
        <Card
          title="Sonar"
          description="Web3 is the dream. The reality is complexity and confusion — but not for long.

          We’re reinventing your crypto journey with a comprehensive suite of tools that provide world-class user experience, data, and education."
          id="3"
        />
        <Card
          title="OpenSea"
          description="The world’s first and largest digital marketplace for crypto collectibles and non-fungible tokens (NFTs). Buy, sell, and discover exclusive digital items."
          id="4"
        /> */}
        <Content />
      </Box>
    </>
  );
};

export default AllDApps;
